import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-flat-message',
  templateUrl: './flat-message.component.html',
  styleUrls: ['./flat-message.component.scss']
})
export class FlatMessageComponent implements OnInit{
  @Input({required: true}) message: string = '';
  @Input() typeMessage: string = '';
  
  typeMessageClass: string = 'informationMessage';
  constructor(){
    
  }
  ngOnInit(): void {

    switch(this.typeMessage){
      case 'info':
        this.typeMessageClass = 'info-card' //se cambió
        break;
			case 'primary': //se agregó
				this.typeMessageClass = 'primary-card'
				break;
			case 'success':
				this.typeMessageClass = 'success-card'
				break;
      case 'warning':
        this.typeMessageClass = 'warn-card'
        break;
      case 'caution':
        this.typeMessageClass = 'caution-card'
        break;
			case 'danger':
				this.typeMessageClass = 'danger-card'
				break;
      case 'info-outline':
        this.typeMessageClass = 'info-card-outline'  //se cambió
        break;
			case 'primary-outline':  //se agregó
				this.typeMessageClass = 'primary-card-outline'
				break;
			case 'sucess-outline':
        this.typeMessageClass = 'success-card-outline'
        break;
      case 'warning-outline':
        this.typeMessageClass = 'warn-card-outline'
        break;
      case 'caution-outline':
        this.typeMessageClass = 'caution-card-outline'
        break;
			case 'danger-outline':
				this.typeMessageClass = 'danger-card-outline'
				break;
      default:
        this.typeMessageClass = ''
    }
  }

}
